import { create } from 'zustand';

export const useAntennaSite = create<{
  ready: boolean;
  rangeM: number;
  detail: number;
  imagery: 'loading' | 'satellite' | 'offline';
  terrain: boolean;
  error: string | null;
}>(() => ({ ready: false, rangeM: 50, detail: 1, imagery: 'loading', terrain: false, error: null }));
